import $http from '../../axios';
import {MessageBox, Notification} from 'element-ui';
import {setAttachments} from './mutations';
import {highestChecked} from './radian_events';

/**
 * Request tipo GET para obtener reception_documents.
 * @author Jhon García
 */
export async function getReceptionDocuments({commit, state}) {

    let params = state.params;

    commit('setPreloader', true);

    await $http
        .get(`/api/reception-documents`, {params})
        .then(response => {
            commit('setReceptionDocuments', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener reception_document.
 * @author Jhon García
 */
export async function getReceptionDocument({commit, state}, id) {

    commit('setPreloader', true);

    await $http
        .get(`/api/reception-documents/${id}`)
        .then(response => {

            let reception_document = response.data.data;
            reception_document.authorized = false;

            commit('setReceptionDocument', reception_document);
            commit('setPdfToReceptionDocument', null);

            if (state.reception_document.contact && state.reception_document.contact.id) {
                commit('setContacts', [state.reception_document.contact]);
            }

            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener Pdf.
 * @author Jhon García
 */
export async function getPdfOfReceptionDocument({commit, state}, id) {

    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http
            .get(`/api/reception-document-annexes/graphical-representation/${id}`)
            .then(response => {
                commit('setPdfToReceptionDocument', response.data.data);
                commit('setPreloader', false);
                resolve(response.data.data);
            })
            .catch(error => {
                commit('setPreloader', false);
                console.error(error);
                Notification.error({
                    title: 'Error!',
                    message: 'No fue posible obtener la representación gráfica del documento',
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}

/**
 * Carga manual de documento (ZIP con XML y PDF)
 */
export async function manualUpload({ commit, dispatch }, formData) {
    commit('setPreloader', true);
    try {
        await $http.post('/api/reception-document/manual-upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        Notification.success({
            title: 'Éxito',
            message: 'Documento cargado exitosamente',
            duration: 2000,
            customClass: 'notification-box'
        });
        commit('setShowToModalManualUpload', false);
        commit('setFileToModalManualUpload', null);
        await dispatch('getReceptionDocuments');
    } catch (error) {
        const msg = error.response.data.error || error.message || 'Error al cargar documento';
        Notification.error({
            title: 'Error',
            message: msg,
            duration: 4000,
            customClass: 'notification-box'
        });
    } finally {
        commit('setPreloader', false);
    }
}

export async function fetchContactsLite({ commit, state, rootState }, text) {
    let params = {
        params: {
            query: text,
            type: 'is_provider'
        }
    };

    console.log(params);

    await $http
        .get("/api/terceros-lite", params)
        .then(response => {
            commit("setContactsLite", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/**
 * Request para obtener datos de branch_offices.
 */
export async function getBranchOffices({commit, state}) {

    let params = {
        paginate: false
    };

    commit('setPreloader', true);

    await $http
        .get(`/api/sedes`, {params})
        .then(response => {
            commit('setBranchOffices', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request para obtener datos de voucher_types.
 */
export async function getVoucherTypes({commit, state}) {

    let params = {
        branchoffice: state.accounting_document.branch_office_id
    };

    commit('setPreloader', true);

    await $http
        .get(`/api/tipos-de-comprobantes`, {params})
        .then(response => {
            commit('setVoucherTypes', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener concepts.
 * @author Jhon García
 */
export async function getConcepts({commit, state}, reset_paginate = false) {

    commit('setPreloader', true);
    let params = state.params_concepts;

    if (reset_paginate) {
        params.page = 1;
    }

    await $http
        .get(`/api/conceptos-contables`, {params})
        .then(response => {
            commit('setConcepts', response.data.data);
            commit('setIdsToParamsConcepts', []);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener concepts.
 * @author Jhon García
 */
export async function getConceptById({commit, state}, id) {

    commit('setPreloader', true);

    await $http
        .get(`/api/conceptos-contables/${id}`)
        .then(response => {
            commit('setConcept', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Obtener suscriptor.
 */
export async function getSubscriber({commit, dispatch, state}) {

    commit('setPreloader', true);

    await $http
        .get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener fiscal_responsibilities.
 * @author Jhon García
 */
export async function getFiscalResponsibilities({commit, state}) {

    commit('setPreloader', true);

    await $http
        .get(`/api/parametros-por-codigo/061?sort_by=name_parameter`)
        .then(response => {
            commit('setFiscalResponsibilities', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo PUT para actualizar la responsabilidad fiscal del tercero.
 * @author Jhon García
 */
export async function updateContact({commit, state}) {

    if (!state.reception_document.contact.id) return;

    commit('setPreloader', true);

    let contact = {
        id: state.reception_document.contact.id,
        fiscal_responsibility_id: state.reception_document.contact.fiscal_responsibility_id
    };

    await $http
        .put(`/api/actualizar-tercero/${contact.id}`, contact)
        .then(response => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Muy bien!',
                message: 'La responsabilidad fiscal del tercero ha sido actualizado exitosamente',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            commit('setPreloader', false);
            MessageBox.alert('Error al actualizar el tercero', 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            });
        });
}

/**
 * Request tipo GET para obetener las cuentas.
 * @author Jhon García
 */
export async function getAccounts({commit, state}) {

    let params = {
        onlyAux: true,
        paginate: false,
        filter: '',
    };

    commit('setPreloader', true);

    await $http
        .get('/api/cuentas', {params})
        .then(response => {
            commit('setAccounts', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Request tipo POST para crear el documento contable.
 * @author Jhon García
 */
export async function createAccountingDocument({commit, state}, data) {

    return new Promise(async (resolve, reject) => {
        commit('setPreloader', true);
        await $http
            .post('/api/crear-documento-contable', data)
            .then(response => {
                commit('setPreloader', false);
                commit('setUrlToModalPdf', response.data.data.accounting_link);
                Notification.success({
                    title: 'Muy bien!',
                    message: 'Documento creado exitosamente',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve(response.data.data);
            })
            .catch(error => {
                commit('setPreloader', false);
                Notification.error({
                    title: 'Error!',
                    message: error.response.data.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}

/**
 * Request tipo GET para obtener los productos de un documento.
 * @author Jhon García
 */
export async function getDetailReferral({commit, state}, id) {

    return new Promise(async (resolve, reject) => {
        commit('setPreloader', true);
        await $http
            .get('/api/pedidos-vendedor-productos/' + id)
            .then(response => {
                commit('setPreloader', false);

                let documents_products = response.data.data.filter(dp => dp.backorder_quantity > 0);

                resolve(documents_products);
            })
            .catch(error => {
                commit('setPreloader', false);
                reject([]);
            });
    });
}

/**
 * Request tipo GET para consultar terceros de tipo proveedor el documento contable.
 * @author Jhon García
 */
export async function getContacts({commit, state}, filter) {

    let params = {
        only_active: true,
        filter: filter,
        type: 'is_provider',
        paginate: false
    };

    await $http
        .get('/api/terceros-lite', {params})
        .then(response => {
            commit('setContacts', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Request tipo GET para consultar el tercero seleccionado.
 * @author Jhon García
 */
export async function getContact({commit, state}, id) {

    commit('setPreloader', true);

    await $http
        .get('/api/terceros/' + id,)
        .then(response => {
            commit('setContactToReceptionDocument', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Request para obtener datos de documents.
 */
export async function getDocuments({commit, state}, restart_page = true) {

    commit('setContactIdToParamsReferrals', state.reception_document.contact_id);

    let params = state.params_referrals;

    if (restart_page) {
        params.page = 1;
    }

    commit('setPreloader', true);

    await $http
        .get(`/api/buscar-documentos`, {params})
        .then(response => {
            commit('setReferrals', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener cost_centers.
 * @author Jhon García
 */
export async function getCostCenters({commit, state}) {

    commit('setPreloader', true);

    await $http
        .get('/api/parametros-por-codigo/038')
        .then(response => {
            commit('setCostCenters', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}


/**
 * Request tipo GET para obtener rejection_reasons.
 * @author Jhon García
 */
export async function getRejectionReasons({commit, state}) {

    commit('setPreloader', true);

    await $http
        .get('/api/parametros-por-codigo/140')
        .then(response => {
            commit('setRejectionReasons', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Request tipo POST para rechazar un documento.
 * @author Jhon García
 */
export async function rejectionDocument({commit, state}, rejection_reason_id) {

    commit('setPreloader', true);

    await $http
        .post('/api/reception-document/reject/' + state.reception_document.id + '/' + rejection_reason_id)
        .then(response => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Muy bien!',
                message: 'Documento rechazado exitosamente',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: 'Error al rechazar el documento',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener contact_warehouse.
 * @author Jhon García
 */
export async function getContactWarehouse({commit, state}) {

    commit('setPreloader', true);

    await $http
        .get(`/api/sucursal-tercero/${state.reception_document.contact_id}`)
        .then(response => {
            commit('setContactWarehouse', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Request tipo POST para autorizar un documento.
 * @author Jhon García
 */
export async function authorizeDocument({commit, state}) {

    commit('setPreloader', true);

    let data = {
        observation: state.modal_authorization.observation,
        target_event: highestChecked(state.modal_authorization.events_checked)
    };

    await $http
            .post('/api/reception-document/authorize/' + state.reception_document.id, data)
        .then(response => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Muy bien!',
                message: 'Documento autorizado exitosamente',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: 'Error al autorizar el documento',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            console.error(error);
        });
}

/**
 * Action para listar todos los adjuntos de documentos de recepción.
 *
 * @param {Object} context El contexto de Vuex (commit, state, etc.).
 * @return {Promise} Promesa que resuelve la lista de adjuntos o rechaza con un error.
 */
export async function fetchAttachments({commit, state}) {
    try {
        const response = await $http.get('/api/reception-documents-attachments/' + state.reception_document.id);
        commit('setAttachments', response.data.data); // Mutación para guardar los adjuntos en el estado
    } catch (error) {
        console.error('Error al obtener adjuntos:', error);
        throw error;
    }
}

/**
 * Action para crear un nuevo adjunto de documento de recepción.
 *
 * @param {Object} context El contexto de Vuex (commit, state, etc.).
 * @param {FormData} formData Los datos del formulario, que incluyen el archivo y otros campos necesarios.
 * @return {Promise} Promesa que resuelve con el adjunto creado o rechaza con un error.
 */
export async function createAttachment({commit, dispatch}, formData) {
    try {
        const response = await $http.post('/api/reception-documents-attachments', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Para enviar archivos
            },
        });

        await dispatch('fetchAttachments');

        commit('setAttachmentToModalAttachments', null);

        Notification.success({
            title: 'Muy bien!',
            message: response.data.message,
            type: 'success',
            duration: 1500,
            customClass: 'notification-box'
        });
    } catch (error) {
        commit('setAttachmentToModalAttachments', null);
        Notification.error({
            title: 'Error!',
            message: 'Error al guardar el adjunto',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
        throw error;
    }
}

/**
 * Action para eliminar un adjunto de documento de recepción por ID.
 *
 * @param {Object} context El contexto de Vuex (commit, state, etc.).
 * @param {Number} attachmentId El ID del adjunto a eliminar.
 * @return {Promise} Promesa que resuelve cuando se elimina el adjunto o rechaza con un error.
 */
export async function deleteAttachment({commit, dispatch}, attachmentId) {
    try {
        await $http.delete(`/api/reception-documents-attachments/${attachmentId}`);
        await dispatch('fetchAttachments');

        Notification.success({
            title: 'Muy bien!',
            message: 'Adjunto eliminado exitosamente',
            type: 'success',
            duration: 1500,
            customClass: 'notification-box'
        });
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: 'Error al eliminar el adjunto',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
        throw error;
    }
}

/**
 * Action para eliminar un adjunto de documento de recepción por ID.
 *
 * @param {Object} context El contexto de Vuex (commit, state, etc.).
 * @param {Number} documents Documentos a cerrar.
 * @return {Promise} Promesa que resuelve cuando se elimina el adjunto o rechaza con un error.
 */
export async function closeDocuments({commit, dispatch}, documents) {
    try {
        await $http.post(`/api/close-reception-documents`, {documents});
        await dispatch('fetchAttachments');

        Notification.success({
            title: 'Muy bien!',
            message: 'Documentos cerrados exitosamente',
            type: 'success',
            duration: 1500,
            customClass: 'notification-box'
        });
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: 'Error al cerrar los documentos',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/modules/reception_documents/actions.js